import { Sheet, SheetContent } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import { X } from 'lucide-react';
import { useState, useEffect } from 'react';
import FormCompanyInvite, { FORM_COMPANY_INVITE_ID } from '../forms/FormCompanyInvite';
import { horodatyApi } from '@/lib/utils/horodaty-api';
import { useTranslation } from 'react-i18next';

export default function SheetCompanyInvite({
    open,
    onClose,
    onSubmit,
    resetKey,
    isSubmitting = false,
    hasOwner = false,
    isSuperAdmin = false,
}) {
    const { t } = useTranslation();
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        if (open) {
            horodatyApi
                .managerGetAvailableRoles()
                .then((response) => {
                    setRoles(response.data.data);
                })
                .catch((error) => {
                    console.error('Erreur lors de la récupération des rôles', error);
                });
        }
    }, [open]);

    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <SheetContent showCloseButton={false} className="w-[min(90vw,480px)] flex flex-col p-0 overflow-hidden">
                {/* Header */}
                <div className="flex items-center justify-between p-5 border-b border-border shrink-0">
                    <h2 className="text-[18px] text-foreground">{t('account:invitezVosCollaborateurs')}</h2>
                    <Button variant="soft" color="neutral" size="xmd" onClick={onClose}>
                        <X className="h-5 w-5" strokeWidth={1.5} />
                    </Button>
                </div>

                <FormCompanyInvite
                    key={resetKey}
                    onSubmit={onSubmit}
                    roles={roles}
                    hasOwner={hasOwner}
                    isSuperAdmin={isSuperAdmin}
                />

                {/* Footer */}
                <div className="border-t border-border p-5 shrink-0">
                    <div className="flex gap-3">
                        <Button
                            variant="soft"
                            color="neutral"
                            size="cta"
                            type="button"
                            onClick={onClose}
                            disabled={isSubmitting}
                        >
                            {t('account:plusTard')}
                        </Button>
                        <SubmitButton
                            isSubmitting={isSubmitting}
                            loadingText={t('account:envoiEnCours')}
                            size="cta"
                            form={FORM_COMPANY_INVITE_ID}
                        >
                            {t('account:inviter')}
                        </SubmitButton>
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    );
}
